(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		KitchenPanel = include('Lemonade.KitchenPanel'),
		Delay = include('springroll.DelayedCall');

	/**
	 * The logic for the title state
	 * @class Lemonade.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var KitchenState = function(options)
	{
		BaseState.call(this, new KitchenPanel(), options);

		this.onIntroComplete = this.onIntroComplete.bind(this);
		this.playRecipeStage = this.playRecipeStage.bind(this);
		this.onRecipeStageComplete = this.onRecipeStageComplete.bind(this);
		this.waitAndExitKitchen = this.waitAndExitKitchen.bind(this);
		this.startTimeout = this.startTimeout.bind(this);
		this.stopTimeout = this.stopTimeout.bind(this);
	};

	//Extend the base state
	var p = extend(KitchenState, BaseState);

	/**
	 * After assets are loaded and state is fully entered
	 * @method  enterDone
	 */
	p.enterDone = function()
	{
		app.state = this;
		app.globalState.currentLocation = "Recipe Screen";

		this.timeoutCount = 0;

		this.recipeStage = 0;
		this.playingRecipeSequence = false;
		this.recipeSequence = [
			{
				stage: "intro",
				vo: "ML_lemons_line1",
				anim: "lemons_in",
				sound: "ses-lem_slidelemmons",
				soundDelay: 600,
				autoplay: true
			},
			{
				stage: "lemons",
				vo: "ML_lemons_line3_1",
				anim: "1lemon",
				sound: "ses-lem_pitcher-lem",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "lemons",
				vo: "ML_lemons_line3_2",
				anim: "2lemon",
				sound: "ses-lem_pitcher-lem",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "lemons",
				vo: "ML_lemons_line3_3",
				anim: "3lemon",
				sound: "ses-lem_pitcher-lem",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "intro",
				vo: "ML_water_line1",
				anim: "water_in",
				sound: "ses-lem_slidecups",
				soundDelay: 0,
				autoplay: true
			},
			{
				stage: "water",
				vo: "Ml_water_line3_1",
				anim: "1water",
				sound: "ses-lem_pitcher-water",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "water",
				vo: "Ml_water_line3_2",
				anim: "2water",
				sound: "ses-lem_pitcher-water",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "water",
				vo: "Ml_water_line3_3",
				anim: "3water",
				sound: "ses-lem_pitcher-water",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "water",
				vo: "Ml_water_line3_4",
				anim: "4water",
				sound: "ses-lem_pitcher-waterlast",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "intro",
				vo: "ML_sugar_line1",
				anim: "sugar_in",
				sound: "ses-lem_slidesugar",
				soundDelay: 0,
				autoplay: true
			},
			{
				stage: "sugar",
				vo: "Ml_sugar_line3",
				anim: "sugar",
				sound: "ses-lem_pitcher-sugar",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "intro",
				vo: "ML_stir_line1",
				anim: "spoon_in",
				sound: "ses-lem_slidespoon",
				soundDelay: 0,
				autoplay: true
			},
			{
				stage: "stir",
				vo: "ML_countstir_line1-3_alt1",
				anim: "stir",
				sound: "ses-lem_stir",
				soundDelay: 0,
				autoplay: false
			},
			{
				stage: "intro",
				vo: "ML_finished_line1",
				anim: "grover_arm_out",
				sound: "ses-lem_spoonlift",
				soundDelay: 0,
				autoplay: true
			},
			{
				stage: "intro",
				vo: "ML_finished_line2",
				anim: null,
				sound: "",
				soundDelay: 0,
				autoplay: true
			}
		];
		this.activeRecipe = this.recipeSequence[0];

		this.panel.playIntroSequence();

		this.componentStart = Math.round((Date.now() - app.globalState.startTime)/ 1000);
		GTM_obj.trackGTMEvent('gameComponentStart', {'componentType' : 'Simulation', 'componentName' : 'Recipe'});
	};

	p.onIntroComplete = function() {
		this.panel.counter.visible = true;
		this.bindEventListeners();
		this.playRecipeStage();
	};

	p.bindEventListeners = function() {
		var i = 0;

		for (i = 0; i < this.panel.lemons.length; i++) {
			var lemon = this.panel.lemons[i];
			lemon.on('click', this.onClickIngredient, this, false, {object: lemon, stage: "lemons"});
		}

		for (i = 0; i < this.panel.water.length; i++) {
			var water = this.panel.water[i];
			water.on('click', this.onClickIngredient, this, false, {object: water, stage: "water"});
		}

		var sugar = this.panel.sugar;
		sugar.on('click', this.onClickIngredient, this, false, {object: sugar, stage: "sugar"});

		var spoon = this.panel.spoon;
		spoon.on('click', this.onClickIngredient, this, false, {object: spoon, stage: "stir"});
	};

	p.unbindEventListeners = function() {

	};

	p.playRecipeStage = function() {
		this.playingRecipeSequence = true;
		if (this.activeRecipe.anim !== null) {
			var animTarget;
			if (this.activeRecipe.anim.indexOf("_in") > -1) {
				// this is a push in animation
				animTarget = this.panel.ingredients;
			} else {
				// this is a pitcher stage
				animTarget = this.panel.pitcher;
				// increase counter every time we add an ingredient
				this.panel.counter.gotoAndStop(this.panel.counter.currentFrame + 1);
			}
			app.sound.play(this.activeRecipe.sound, {delay: this.activeRecipe.soundDelay});
			app.animator.play(animTarget, {anim: this.activeRecipe.anim});
			
		}
		app.voPlayer.stop();
		app.voPlayer.play(this.activeRecipe.vo, this.onRecipeStageComplete);

		app.state.stopTimeout();
		
	};

	p.onRecipeStageComplete = function() {
		this.playingRecipeSequence = false;
		this.recipeStage++;

		app.state.startTimeout();

		if (this.recipeStage >= this.recipeSequence.length) {

			this.waitAndExitKitchen();
		} else {
			this.activeRecipe = this.recipeSequence[this.recipeStage];

			if (this.activeRecipe.stage === "stir") {
				this.panel.counter.visible = false;
			}

			if (this.activeRecipe.autoplay) {
				// reset the counter when new ingredients become available
				this.panel.counter.gotoAndStop(0);
				this.playRecipeStage();
			}
		}
	};

	p.onClickIngredient = function(evt, data) {
		if (this.activeRecipe.stage === data.stage && this.playingRecipeSequence === false) {
			this.playRecipeStage();
			data.object.visible = false;
		}

		if (this.panel.gtmTimeoutStart > -1) {
			var duration = Math.round((Date.now() - app.globalState.startTime)/ 1000) - this.panel.gtmTimeoutStart;
			GTM_obj.trackGTMEvent('gameTOReEngage', {'duration' : duration});
			this.panel.gtmTimeoutStart = -1;
		}
	};

	p.waitAndExitKitchen = function() {
		var duration = Math.round((Date.now() - app.globalState.startTime)/ 1000) - this.componentStart;
		GTM_obj.trackGTMEvent('gameComponentComplete', {'duration' : duration, 
			'componentType' : 'Simulation', 'componentName' : 'Recipe'});

		var nextStateTimeout = new Delay(function(){
			this.nextState();
		}.bind(this), 100);
	};

	p.startTimeout = function(resetCount) {
		// housekeeping and analytics tracking
		if (typeof resetCount === "undefined") {
			resetCount = true;
		}
		if (this.timeout) {
			this.timeout.destroy();
		}

		if (resetCount) {
			this.timeoutCount = 0;
		}

		// timer logic
		this.timeout = new Delay((function(){
			// set analytics vars
			app.state.timeoutCount += 1;

			if (app.voPlayer.playing) {
				// don't interrupt playing VO
				app.state.startTimeout(true);
				return;
			}

			var voList = [];

			if (this.activeRecipe.stage === "lemons") {
				voList.push("ML_lemons_line2a");
			} else if (this.activeRecipe.stage === "water") {
				voList.push("ML_water_line2a");
			} else if (this.activeRecipe.stage === "sugar") {
				voList.push("ML_sugar_line2a");
			} else if (this.activeRecipe.stage === "stir") {
				voList.push("ML_stir_line2a");
			}

			app.voPlayer.play(voList, function(){
				app.state.startTimeout(false);
			});

			if (this.panel.gtmTimeoutStart < 0) {
				this.panel.gtmTimeoutStart = Math.round((Date.now() - app.globalState.startTime)/ 1000);
			}

			GTM_obj.trackGTMEvent('gameTimeoutPlay');
			
		}.bind(this)), 10000);
	};

	p.stopTimeout = function() {
		if (this.timeout) {
			this.timeout.destroy();
		}
		app.state.timeoutCount = 0;
		app.state.timeoutStartTime = 0;
	};

	/**
	 * When the state starts to exit, before transition
	 * @method  exitStart
	 */
	p.exitStart = function()
	{
		this.stopTimeout();
		app.voPlayer.stop();

		app.animator.stopAll();
		createjs.Tween.removeTweens(this.panel.kitchen);
		createjs.Tween.removeTweens(this.panel.kitchen.children[0]);
		createjs.Tween.removeTweens(this.panel.grover);
		createjs.Tween.removeTweens(this.panel.elmo);
	};

	//Assign to namespace
	namespace('Lemonade').KitchenState = KitchenState;
}());